import {UserEmailKey, UserNameKey} from "../../utils/request";
import store from '../../store'

const deliverNum = {
  title: 'Delivery Number',
  inputStyle: 'text',
  placeholder: 'Please enter delivery number',
  valid: true,
  value: '',
  isOk: true,
  code: 'lvo_deliverynumber',
  maxLength: 10,
  errorMsg: 'Please input a valid value'
}
const salesOrder = {
  title: 'Sales Order',
  inputStyle: 'text',
  placeholder: '',
  valid: true,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value'
}
const partNumber = {
  title: 'Part Number',
  inputStyle: 'text',
  placeholder: '',
  valid: true,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value'
}
const orderQuantity = {
  title: 'Order Quantity',
  inputStyle: 'text',
  placeholder: '',
  valid: true,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value'
}
const lenovoReference = {
  title: 'Lenovo Reference',
  inputStyle: 'text',
  placeholder: 'Please enter Lenovo Reference',
  valid: true,
  isOk: true,
  code: 'lvo_lenovoreference',
  value: '',
  errorMsg: 'Please input a valid value'
}

const carrierRespStatus = {
  title: 'Carrier Response Result',
  inputStyle: 'label',
  placeholder: '',
  valid: false,
  isOk: true,
  code: 'carrierRespStatus',
  value: '',
  errorMsg: 'Please input a valid value'
}
const parentDN = {
  title: 'Parent DN',
  inputStyle: 'label',
  placeholder: '',
  valid: false,
  isOk: true,
  code: 'parentDN',
  value: '',
  errorMsg: ''
}

const name = {
  title: 'Name',
  inputStyle: 'text',
  placeholder: 'Please Enter Name',
  valid: true,
  value: getUserName(),
  isOk: true,
  code: 'lvo_requestorsname',
  errorMsg: 'Please input a valid value'
}

const email = {
  title: 'Email',
  inputStyle: 'localSelect',
  placeholder: 'Please enter Email',
  valid: true,
  isOk: true,
  value: '',
  code: 'lvo_requestorsemail',
  errorMsg: 'Please input a valid value'
}
const phone = {
  title: 'Phone',
  inputStyle: 'text',
  placeholder: 'Please enter Phone',
  valid: false,
  isOk: true,
  value: getUserPhone(),
  errorMsg: 'Please input a valid value',
  code: 'lvo_requestorsphone'
}
const emailSubject = {
  title: 'Email Subject',
  inputStyle: 'text',
  placeholder: 'Please enter Email Subject',
  valid: false,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value',
  code: 'lvo_originalemailsubject'
}

const taskId = {
  title: 'Task ID',
  inputStyle: 'text',
  placeholder: '',
  valid: false,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value',
  code: ''
}
const dateOfRefusal = {
  title: 'Date Of Refusal',
  inputStyle: 'date',
  placeholder: 'Please select Date Of Refusal',
  valid: true,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value',
  code: 'lvo_dateofrefusal'
}

const DeadlineOfApproval = {
  title: 'Deadline of approval',
  inputStyle: 'dateTime',
  dataIndex: 'lvo_deadlineforapproval',
  placeholder: 'Please select time Of Deadline',
  valid: true,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value'
}
const extraCost = {
  title: 'Extra Cost',
  inputStyle: 'text',
  placeholder: 'Please enter Extra Cost',
  value: '',
  isOk: true,
  valid: true,
  errorMsg: 'Please input a valid value',
  code: ''
}
const reasonOfRefusal = {
  title: 'Reason Of Refusal',
  inputStyle: 'select',
  placeholder: 'Please Select Reason Of Refusal',
  valid: true,
  isOk: true,
  errorMsg: 'Please input a valid value',
  value: [],
  code: 'lvo_reasonofrefusal',
  selectArray: [
    {
      name: 'Custom did not order these goods',
      value: 'reason1'
    },
    {
      name: 'Address/business closed',
      value: 'reason2'
    },
    {
      name: 'Wrong address',
      value: 'reason3'
    },
    {
      name: 'Missing contact',
      value: 'reason4'
    },
    {
      name: 'CSR not followed',
      value: 'reason5'
    },
    {
      name: 'Damaged or missing goods',
      value: 'reason6'
    },
    {
      name: 'Missing paperwork',
      value: 'reason7'
    },
    {
      name: 'Customer deferral',
      value: 'reason8'
    },
    {
      name: 'Other',
      value: 'reason9'
    }
  ]
}
const cost = {
  title: 'Extra Cost',
  inputStyle: 'number',
  placeholder: 'Please input cost',
  valid: false,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value',
  code: 'lvo_costofextraservice'
}

const aCost = {
  title: 'Cost',
  inputStyle: 'number',
  placeholder: 'Please input cost',
  valid: false,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value',
  code: 'lvo_cost'
}

const invoiceNumber = {
  title: 'Invoice Numbers',
  inputStyle: 'text',
  placeholder: 'Please Enter Invoice Numbers',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_invoicenumber',
  errorMsg: 'Please input a valid value'
}
const currency = {
  title: 'Currency',
  inputStyle: 'select',
  placeholder: 'Please Select Currency',
  valid: true,
  isOk: true,
  code: 'transactioncurrencyid',
  errorMsg: 'Please input a valid value',
  value: [],
  selectArray: [
    {
      name: 'None',
      value: 'none'
    },
    {
      name: 'EUR',
      value: 'EUR'
    },
    {
      name: 'USD',
      value: 'USD'
    },
    {
      name: 'CHF',
      value: 'CHF'
    },
    {
      name: 'GBP',
      value: 'GBP'
    }
  ]
}
const reasonForRequest = {
  title: 'Reason For Request',
  inputStyle: 'select',
  placeholder: 'Please Select Reason For Request',
  valid: true,
  errorMsg: 'Please input a valid value',
  value: [],
  code: 'lvo_reasonforrequest',
  isOk: true,
  selectArray: [
    {
      name: 'None',
      value: 'none'
    },
    {
      name: 'Extra Service Requested by Customer',
      value: 'reason2'
    },
    {
      name: 'Other',
      value: 'other'
    }
  ]
}
const reasonForRequest2 = {
  title: 'Reason For Request',
  inputStyle: 'select',
  placeholder: 'Please Select',
  valid: false,
  errorMsg: 'Please input a valid value',
  value: [],
  isOk: true,
  selectArray: [
    {
      name: 'None',
      value: 'none'
    },
    {
      name: 'Change of Address',
      value: 'reason2'
    },
    {
      name: 'Collection and Redelivery',
      value: 'reason3'
    },
    {
      name: 'Expedite',
      value: 'reason4'
    },
    {
      name: 'Extra Service Requested by Customer',
      value: 'reason5'
    },
    {
      name: 'Waiting or Demuurage Charge Due to Later Delivery',
      value: 'reason6'
    },
    {
      name: 'Other',
      value: 'other'
    }
  ]
}

const comments = {
  title: 'Comments',
  inputStyle: 'textarea',
  placeholder: 'Maximum 2000 Characters',
  value: '',
  valid: false,
  isOk: true,
  code: 'lvo_comments',
  errorMsg: 'Please input a valid value'
}

const RootCauseofDamage = {
  title: 'Root Cause of Damage',
  inputStyle: 'textarea',
  placeholder: 'Please Enter Root Cause of Damage',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_rootcauseofdamage',
  errorMsg: 'Please input a valid value'
}
const serialNumber = {
  title: 'Serial Number',
  inputStyle: 'text',
  placeholder: 'Please Enter Serial Number',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_serialnumber',
  errorMsg: 'Please input a valid value'
}
const damagedQuantity = {
  title: 'Damaged Quantity',
  inputStyle: 'number',
  placeholder: 'Please Enter Damaged Quantity',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_damagedquantity',
  errorMsg: 'Please input a valid value'
}
const damageLevel = {
  title: 'Damage Level',
  inputStyle: 'select',
  placeholder: 'Please Select Damage Level',
  valid: false,
  isOk: true,
  value: [],
  code: 'lvo_damagelevel',
  errorMsg: 'Please input a valid value',
  selectArray: [
    {
      name: 'None',
      value: '0'
    },
    {
      name: 'Level 1',
      value: '1'
    },
    {
      name: 'Level 2',
      value: '2'
    },
    {
      name: 'Level 3',
      value: '3'
    },
    {
      name: 'Level 4',
      value: '4'
    }
  ]
}
const relatedDeliveryNumbers = {
  title: 'Related Delivery Numbers',
  inputStyle: 'textarea',
  placeholder: 'Maximum 2000 Characters (Please use ; as separation icon)',
  value: '',
  valid: false,
  isOk: true,
  errorMsg: 'Please input a valid value',
  code: 'lvo_relateddeliverynumbers'
}
const caseNumber = {
  title: 'Case Numbers',
  inputStyle: 'text',
  placeholder: 'Please Enter Case Numbers',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_casenumber',
  errorMsg: 'Please input a valid value'
}

const cusdecmissing = {
  title: 'EDI Category',
  name: 'CUSDEC',
  inputStyle: 'checkbox',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_cusdecmissing'
}

const invoicmissing = {
  title: ' ',
  name: 'INVOIC',
  inputStyle: 'checkbox',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_invoicmissing'
}

const desadvmissing = {
  title: ' ',
  name: 'DESADV',
  inputStyle: 'checkbox',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_desadvmissing'
}

const EDICategory = {
  title: 'EDI Category',
  inputStyle: 'checkbox',
  placeholder: '',
  valid: false,
  isOk: true,
  errorMsg: 'Please Select a valid value',
  value: [],
  selectArray: [
    {
      name: 'CUSDEC',
      value: 'lvo_cusdecmissing'
    },
    {
      name: 'INVOIC',
      value: 'lvo_invoicmissing'
    },
    {
      name: 'DESADV',
      value: 'lvo_desadvmissing'
    }

  ]
}
const attachment = {
  title: 'Attachment',
  inputStyle: 'upload',
  placeholder: '',
  valid: false,
  isOk: true,
  value: null,
  errorMsg: 'Please input a valid value',
  code: 'attachment'
}

const attachment1 = {
  title: 'Attachment1',
  inputStyle: 'upload',
  placeholder: '',
  valid: false,
  isOk: true,
  value: null,
  errorMsg: 'Please input a valid value',
  code: 'attachment1'
}
const attachment2 = {
  title: 'Attachment2',
  inputStyle: 'upload',
  placeholder: '',
  valid: false,
  isOk: true,
  value: null,
  errorMsg: 'Please input a valid value',
  code: 'attachment2'
}
const attachment3 = {
  title: 'Attachment3',
  inputStyle: 'upload',
  placeholder: '',
  valid: false,
  isOk: true,
  value: null,
  errorMsg: 'Please input a valid value',
  code: 'attachment3'
}

const customerName = {
  title: 'Customer Name',
  inputStyle: 'text',
  placeholder: '',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_collectioncustomername',
  errorMsg: 'Please input a valid value'
}
const customerStreet = {
  title: 'Customer Street',
  inputStyle: 'text',
  placeholder: '',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_collectioncustomerstreet',
  errorMsg: 'Please input a valid value'
}
const CustomerPostCode = {
  title: 'Customer Post Code',
  inputStyle: 'text',
  placeholder: '',
  value: '',
  valid: false,
  isOk: true,
  code: 'lvo_collectioncustomerpostalcode',
  errorMsg: 'Please input a valid value'
}
const CustomerCity = {
  title: 'Customer City',
  inputStyle: 'text',
  placeholder: '',
  valid: false,
  isOk: true,
  code: 'lvo_collectioncustomercity',
  value: '',
  errorMsg: 'Please input a valid value'
}
const CustomerCountry = {
  title: 'Customer Country',
  inputStyle: 'text',
  placeholder: '',
  value: '',
  valid: false,
  code: 'lvo_collectioncustomercountry',
  isOk: true,
  errorMsg: 'Please input a valid value'
}
const CustomerContactName = {
  title: 'Customer Contact Name',
  inputStyle: 'text',
  placeholder: '',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_collectioncustomercontactname',
  errorMsg: 'Please input a valid value'
}
const BookingRequestedDate = {
  title: 'Booking Requested Date',
  inputStyle: 'date',
  placeholder: '',
  value: null,
  valid: true,
  isOk: true,
  code: 'lvo_bookingrequesteddate',
  errorMsg: 'Please input a valid value'
}
const BookingConfirmeddDate = {
  title: 'Booking Confirmed  Date',
  inputStyle: 'date',
  placeholder: '',
  value: null,
  valid: true,
  isOk: true,
  code: 'lvo_bookingconfirmedfordate',
  errorMsg: 'Please input a valid value'
}
const country = {
  title: 'country',
  inputStyle: 'select',
  placeholder: 'Please select country',
  valid: true,
  isOk: true,
  code: 'lvo_country',
  errorMsg: 'Please input a valid value',
  value: [],
  selectArray: [
    {
      name: 'None',
      code: 'None'
    }
  ]
}
const Carrier = {
  title: 'Carrier',
  inputStyle: 'select',
  placeholder: 'Please input carrier',
  valid: false,
  isOk: true,
  code: 'lvo_carrier',
  errorMsg: 'Please input a valid value',
  value: [],
  selectArray: [
    {
      name: 'None',
      code: 'None'
    },
    {
      name: 'DHL',
      code: 'DHL'
    },
    {
      name: 'Expeditors',
      code: 'Expeditors'
    },
    {
      name: 'Flextronics',
      code: 'flextronics'
    },
    {
      name: 'Kuehne and Nagel',
      code: 'kan'
    },
    {
      name: 'UPS',
      code: 'UPS'
    },
    {
      name: 'Not specific to one carrier',
      code: 'notspec'
    },
    {
      name: 'carrier unknown',
      code: 'unknown'
    }
  ]
}
const PackingListType = {
  title: 'Packing List Type',
  inputStyle: 'select',
  placeholder: '',
  valid: true,
  isOk: true,
  code: 'lvo_packinglisttype',
  errorMsg: 'Please input a valid value',
  value: [],
  selectArray: [
    {
      name: 'None',
      code: 'None'
    },
    {
      name: 'Copy of packing list',
      code: 'cpl'
    },
    {
      name: 'Manufactury',
      code: 'mau'
    }
  ]
}
const DamageType = {
  title: 'Damage Type',
  inputStyle: 'select',
  placeholder: '',
  valid: true,
  isOk: true,
  code: 'lvo_damagetype',
  errorMsg: 'Please input a valid value',
  value: [],
  selectArray: [
    {
      name: 'None',
      code: 'None'
    },
    {
      name: 'Change of Address',
      code: 'changeAddress'
    },
    {
      name: 'Collection and Redelvery',
      code: 'reason3'
    },
    {
      name: 'Expedite',
      code: 'reason4'
    },
    {
      name: 'Extra Service Requested by Customer',
      code: 'reason5'
    },
    {
      name: 'Waiting or Demuurage Charge Due to Later Delivery',
      code: 'reason6'
    },
    {
      name: 'Other',
      code: 'reason7'
    }
  ]
}
const CustomerContactEmai = {
  title: 'Customer Contact Email',
  inputStyle: 'text',
  placeholder: '',
  value: '',
  valid: false,
  isOk: true,
  code: 'lvo_collectioncustomercontactemail',
  errorMsg: 'Please input a valid value'
}
const CustomerPhone = {
  title: 'Customer Contact Phone',
  inputStyle: 'text',
  placeholder: 'Please enter Customer Phone',
  valid: false,
  isOk: true,
  value: '',
  code: 'lvo_collectioncustomercontactphone',
  errorMsg: 'Please input a valid value'
}
const CustomerReferenceNumber = {
  title: 'Customer Reference Number',
  inputStyle: 'text',
  placeholder: '',
  valid: false,
  isOk: true,
  errorMsg: 'Please input a valid value',
  value: '',
  code: 'lvo_collectioncustomerreferencenumber'
}

export const caseShowItem = {
  lvo_deliverynumber: deliverNum,
  lvo_relateddeliverynumbers: relatedDeliveryNumbers,
  lvo_requestorsname: name,
  lvo_requestorsemail: email,
  lvo_requestorsphone: phone,
  lvo_originalemailsubject: emailSubject,
  lvo_comments: comments,
  attachment: attachment,
  lvo_dateofrefusal: dateOfRefusal,
  lvo_costofextraservice: cost,
  lvo_reasonofrefusal: reasonOfRefusal,
  lvo_cost: aCost,
  transactioncurrencyid: currency,
  lvo_reasonforrequest: reasonForRequest,
  lvo_country: country,
  lvo_carrier: Carrier,
  lvo_deadlineforapproval: DeadlineOfApproval,
  lvo_serialnumber: serialNumber,
  lvo_damagedquantity: damagedQuantity,
  lvo_damagelevel: damageLevel,
  lvo_rootcauseofdamage: RootCauseofDamage,
  attachment1: attachment1,
  attachment2: attachment2,
  attachment3: attachment3,
  lvo_casenumber: caseNumber,
  lvo_invoicenumber: invoiceNumber,
  lvo_invoicmissing: invoicmissing,
  lvo_desadvmissing: desadvmissing,
  lvo_cusdecmissing: cusdecmissing,
  lvo_collectioncustomername: customerName,
  lvo_collectioncustomerstreet: customerStreet,
  lvo_collectioncustomerpostalcode: CustomerPostCode,
  lvo_collectioncustomercity: CustomerCity,
  lvo_collectioncustomercountry: CustomerCountry,
  lvo_collectioncustomercontactname: CustomerContactName,
  lvo_collectioncustomercontactemail: CustomerContactEmai,
  lvo_collectioncustomercontactphone: CustomerPhone,
  lvo_collectioncustomerreferencenumber: CustomerReferenceNumber,
  lvo_bookingrequesteddate: BookingRequestedDate,
  lvo_bookingconfirmedfordate: BookingConfirmeddDate,
  lvo_packinglisttype: PackingListType,
  lvo_damagetype: DamageType,
  lvo_lenovoreference:  lenovoReference,
  carrierRespStatus: carrierRespStatus,
  superDlyNum: parentDN,
}

function getUserName() {
  var userName = store.getters.getUserName
  // this.$store.state.userInfo.userName
  if (userName) return userName;
  return ''
}

function getEmail() {
  var email = store.getters.getUserEmail
  if (email) return email;
  return ''
}

function getUserPhone() {
  var phone = store.getters.getUserPhone
  if (phone) return phone;
  return ''
}


export const PDFFIleConfig =  {
  'dcg-carrier packing list request': '/carrier/dcg- carrier packing list request',
  'dcg-delivery refusal': '/carrier/DCG- Delivery Refusal',
  'dcg-extra cost, extra service': '/carrier/DCG- Extra Cost, Extra Service',
  'dcg-other': '/carrier/DCG- Other',
  'dcg-request for missing information': '/carrier/DCG- Request for missing information',
  'dcg-shipment is damaged': '/carrier/dcg- shipment is damaged',
  'dcg-customer contact detail': '/carrier/IDG- customer contact detail',
  'idg-customer deferal help': '/carrier/IDG- customer deferal help',
  'idg-delivery refusal by customer': '/carrier/IDG- delivery refusal by customer',
  'idg-edi missing': '/carrier/IDG- EDI Missing',
  'idg-extra cost from carrier': '/carrier/IDG- Extra cost from carrier',
  'idg-invoice missing': '/carrier/IDG- Invoice missing',
  'idg-other': '/carrier/IDG- Other',
  'idg-packing list request': '/carrier/IDG- packing list request',
  'idg-shipment is damage': '/carrier/IDG- shipment is damage',
}
